import React, { useState, useRef, useEffect } from 'react';
import { X, ChevronLeft } from 'lucide-react';
import Logo from '../../../../assets/GreenLogo.svg';
import Darklogo from "../../../../assets/Whitelogo.svg";
import useReCaptcha from "../../../../Providers/Captchaservice/useReCaptcha";
import { encryptUserId } from "../../../Common/cryptoUtils";

import Input from '../Input/Input';
import { useTheme } from '../../../Layout/ThemeContext/ThemeContext'; // Import the theme context
import createForgotPasswordEmailBody from "../../../../components/email/ForgotPasswordTemplate";

export default function ForgetPassword({ onClose, onBackToLogin, onSignup, onNext ,code, setCode, expiryTime, setExpiryTime,setIsSuccess,
  setIsMsgStatus,
  setModalMessage}) {
  const [formData, setFormData] = useState({
    email: '',
  });

  const modalRef = useRef(null);
  const { isDarkMode, isLangArab } = useTheme(); // Access the dark mode state
  const [message, setMessage] = useState('');
  const { getReCaptchaToken } = useReCaptcha();


  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose();
      }
    };

    document.addEventListener('mousedown', handleOutsideClick);
    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, [onClose]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };


  console.log('formData.email :>> ', formData.email);
  const handleSubmit = async(e) => {
    e.preventDefault();   
    generateCode();
    // console.log('Reset password for:', formData.email);
    // const emailData = {
    //   email: formData.email
    // };
    // // const token = await getReCaptchaToken("forgotPassword");
    // // if (!token) {
    // //   alert("reCAPTCHA validation failed. Please try again.");
    // //   return;
    // // }
    // try {
    //   const response = await fetch(
    //     `${process.env.REACT_APP_API_URL}/Registration/check-email`,
    //     {
    //       method: "POST",
    //       headers: {
    //         "Content-Type": "application/json",
    //       },
    //       body: JSON.stringify(formData.email),
    //     }
    //   );
  
    //   const result = await response.json();
    //   if (result.success) {
    //     //setCode(result.data.code); // Store the code
    //     //setExpiryTime(result.data.expiryTime); 
    //     onNext(formData.email);
    //     generateCode();
    //   } else {
    //     //console.log(result.message || "Email sending failed. Please try again.");
    //     setMessage( isLangArab? result.message === "The email is not associated with any account." && "البريد الإلكتروني غير مرتبط بأي حساب":result.message); // Display success message
    //   }
    // } catch (error) {
    //   console.error("Error sending email:", error);
    // }
    //onNext(formData.email);
  };
  const generateCode = async () => {
    const CaptechaToken = await getReCaptchaToken("forgotPassword");
    if (!CaptechaToken) {
      alert("reCAPTCHA validation failed. Please try again.");
      return;
    }
    const encryptedText = encryptUserId(formData.email);
    const emailData = {
      toEmail: encryptedText,
      isLangArabic: isLangArab,
      captchatoken: CaptechaToken
    };
  
    try {
      //const token = localStorage.getItem("token");
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/Email/ResetPasswordRequest`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(emailData),
        }
      );
  
      const result = await response.json();
      if (result.success) {
        onNext(formData.email);
        //setCode(result.data.code); // Store the code
        //setExpiryTime(result.data.expiryTime); 
      } else {
        if(result.message == "The email address is not registered."){
          setMessage( !isLangArab? "The email is not associated with any account.": "البريد الإلكتروني غير مرتبط بأي حساب"); // Display success message
        }
        else{
          console.log(result.message || "Email sending failed. Please try again.");
          setMessage(result.message || "Email sending failed. Please try again.");
        }
      }
    } catch (error) {
      console.error("Error sending email:", error);
    }
  };
  
  // useEffect(() => {
  //   if (expiryTime) {
  //     const timer = setInterval(() => {
  //       if (Date.now() >= expiryTime) {
  //         setCode(""); // Clear the code after expiry
  //         setExpiryTime(null);
  //         alert("Your code has expired.");
  //         clearInterval(timer);
  //       }
  //     }, 1000);

  //     // Cleanup the timer on component unmount
  //     return () => clearInterval(timer);
  //   }
  // }, [expiryTime]);

  return (
    <div dir={isLangArab && "rtl"} className="fixed sm:inset-10 flex items-center justify-center z-50 sm:p-4 px-1">
      <div
        ref={modalRef}
        className={`p-9 sm:p-12 md:p-12 mb-12 rounded-2xl border shadow-lg w-full max-w-sm relative transition-colors duration-300 ${
          isDarkMode ? 'bg-[rgba(96,96,96,0.8)] text-white' : 'bg-white bg-opacity-50 backdrop-filter backdrop-blur-lg text-black'
        }`}      >
        <button
          className={`absolute top-4 ${ isLangArab?" left-4":"right-4"} hover:text-gray-800 ${
            isDarkMode ? "text-[#FFFFFFFF] text-opacity-80" : "text-gray-800"
          }`}
          onClick={onClose}
        >
          <X className={`w-5 h-5 ${isDarkMode?" text-white":"text-black"}`} />
        </button>
        <div className="flex justify-center mb-2">
          <img src={ isDarkMode? Darklogo : Logo} alt="Logo" className="h-12" />
        </div>
        <div className="flex flex-col justify-between h-full">
          <div className="w-full">
            <button
              className={`flex items-center text-[14px] ${isDarkMode ? 'text-gray-300' : 'text-gray-600'} hover:underline mb-4 mt-8 sm:mt-12`}
              onClick={onBackToLogin}
            >
              <ChevronLeft className={`w-6 h-6 ${isLangArab && " rotate-180"} mr-1 ${isDarkMode ? 'text-white' : 'text-black'}`} />
              {isLangArab?"العودة لتسجيل الدخول":"Back to sign in"}
            </button>
            <h2 className={`text-[24px] sm:text-[28px] font-medium ${isDarkMode ? 'text-white' : 'text-black'} mb-2`}>{isLangArab?"هل نسيت كلمة السر":"Forgot Password"}</h2>
            <p className={`text-[14px]   font-regular text-${isDarkMode ? '[#FFFFFFCC]' : 'gray-600'} mb-4`}>
              {isLangArab?"أدخل بريدك الإلكتروني وسنرسل لك رابطًا لإعادة تعيين كلمة المرور الخاصة بك":"Enter your email and we'll send you a link to reset your password"}
            </p>
            <form onSubmit={handleSubmit} className="space-y-4 flex-grow">
              <Input
                type="email"
                name="email"
                placeholder={isLangArab?"أدخل بريدك الإلكتروني":"Enter your Email id"}
                onChange={handleChange}
              />
              {message  && <span className="text-red-500 text-xs">{message}</span>}
              <button
                type="submit"
                className={`w-full py-3 rounded-xl transition duration-300 text-sm ${
                  formData.email
                    ? 'bg-gradient-to-r from-[#036068] via-[#596451] to-[#1199A8] text-white'
                    : `${isDarkMode ? 'bg-[white] bg-opacity-20 text-white' : 'bg-[#82828280] text-white'}`
                }`}
                disabled={!formData.email}
              >
                {isLangArab?"التالي":"Next"}
              </button>
            </form>
            <div className="mt-auto pt-2 text-center">
              <p className={`text-sm text-${isDarkMode ? '[#FFFFFFCC]' : 'gray-600'} text-center mt-10`}>
              {isLangArab ? "ليس لديك حساب":"Don't have an account?"}{' '}
                <button onClick={onSignup} className={`${isDarkMode ? ' text-white hover:text-white/80' : 'text-[#004987]'} font-medium underline`}>
                {isLangArab?"تسجيل":"Sign Up"}
                </button>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
